<template>
    <div class="container-fluid">
        <NavTabs>
            <NavTab target="open-positions" :activeTab="activeTab" @update:activeTab="activeTab = $event">
                Sign-up Positions
            </NavTab>
            <NavTab target="my-interests" :activeTab="activeTab" @update:activeTab="activeTab = $event">
                My Interests
            </NavTab>
        </NavTabs>

        <ContentContainer>
            <template #content>
                <div v-if="activeTab === 'open-positions'">
                    <OpenPositions :locationID="locationID" :userID="userID" @open-interests="activeTab = 'my-interests'" />
                </div>

                <div v-else-if="activeTab === 'my-interests'">
                    <SignupInterests :locationID="locationID" :userID="userID" />
                </div>
            </template>
        </ContentContainer>
    </div>
</template>

<script setup>
import { ref } from "vue";
import NavTab from "../../components/Tabs/NavTab.vue";
import NavTabs from "../../components/Tabs/NavTabs.vue";
import ContentContainer from "../../components/PageLayout/ContentContainer.vue";
import OpenPositions from "./components/OpenPositions.vue";
import SignupInterests from "./components/SignupInterests.vue";

defineProps({
    locationID: {
        type: String,
        default: null
    },
    userID: {
        type: String,
        default: null
    }
});

const activeTab = ref("open-positions"); // default active tab
</script>